import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, ONE_ELEMENT, PARAMS} from 'util/constants';
import {getCurrentDate} from 'util/date';


const _getCustomerActionNeeded = can =>

    /*if (can === false || can === '' || can === 'false') {

        return false;
    }*/

    false

;

const _getFetchParams = (filters, pagination, sortBy, language) => {
    if (filters.customerActionNeeded === false) {
        return {
            state:    filters.status,
            ...pagination,
            ordering: sortBy,
            language,
            search:   filters.search
        };
    }

    return {
        state:                  filters.status,
        ...pagination,
        ordering:               sortBy,
        language,
        search:                 filters.search,
        customer_action_needed: PARAMS.TRUE
    };
};

const
    mapFields = {
        caller_id:            'callerId',
        company:              'company',
        impact:               'impact',
        short_description:    'title',
        description:          'comment',
        u_id_ticket_customer: 'idTicketCustomer',
        u_watch_list_new:     'serviceNowUsers',
        service_offering:     'serviceOfferingId'
    },
    transformEntitiesToSaveFn = data => Object.keys(mapFields).reduce((ret, key) => ({
        ...ret,
        [key]: data[mapFields[key]]
    }), {});

module.exports = {
    mapFields,
    transformEntitiesToSaveFn,
    createFetchParams: (filters, pagination, sortBy, language) => _getFetchParams(filters, pagination, sortBy, language),
    ...storeModuleFactory({
        name:            'issues',
        endpoint:        endpoints.serviceNow.issuesEndpoint,
        timeout:         TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        filterParamsMap: {
            serviceOffering: 'service_offering',
            status:          'state'
        },
        sortParamsMap: {
            creationUser:        'opened_by',
            serviceNowId:        'number',
            accountName:         'company',
            requesterName:       'caller_id',
            serviceOfferingText: 'service_offering',
            stateName:           'state'
        },
        instanceEndpoint:    endpoints.serviceNow.detailIssueEndpoint,
        transformEntitiesToSaveFn,
        transformEntitiesFn: item => ({
            id:               item.id,
            serviceNowId:     item.number,
            serviceNowIdText: `#${item.number}`,
            creationUser:     {
                firstName: item.opened_by.name,
                id:        item.opened_by.id
            },
            customerActionPending: _getCustomerActionNeeded(item.customer_action_needed),
            requester:             {
                firstName: item.requester.name,
                id:        item.requester.id
            },
            requesterName:      item.requester.name,
            creationUserName:   item.opened_by.name,
            customerTicketId:   item.customer_ticket_id,
            title:              item.title,
            description:        item.description,
            watchList:          item.watch_list,
            created:            item.created_date,
            datetime:           getCurrentDate(item.creation_date),
            date:               item.creation_date,
            accountName:        item.company ? item.company.name : '',
            totalMessages:      item.comments ? item.comments.length : '',
            formatTotalMessage: item.comments ? item.comments.length === ONE_ELEMENT ? 'singularComment' : 'pluralComment' : '',
            activity:           item.comments ? item.comments.map(itemActivity => ({
                id:        itemActivity.sys_id,
                name:      itemActivity.opened_by.name,
                value:     itemActivity.description,
                createdOn: getCurrentDate(itemActivity.creation_date)
            })) : [],
            serviceOfferingText: item.service_offering ? item.service_offering.name : '',
            serviceOffering:     item.service_offering && {
                id:   item.service_offering.id,
                name: item.service_offering.name
            },
            company:     item.company.name,
            stateName:   item.state.name,
            state:       item.state ? item.state.id : '',
            impact:      item.impact ? item.impact.id : '',
            viewState:   item.state ? item.state : '',
            viewImpact:  item.impact ? item.impact : '',
            attachments: item.attachments ? item.attachments.map(itemAttachment => ({
                fileName:    itemAttachment.file_name,
                sysId:       itemAttachment.sys_id,
                contentType: itemAttachment.content_type,
                size:        itemAttachment.size
            })) : []
        }),
        extraActions: [{
            method: 'update',
            action: 'createComment',
            url:    endpoints.serviceNow.createCommentIssueEndpoint,
            start:  state => ({
                ...state,
                isCommenting: true,
                error:        null
            }),
            success: state => ({
                ...state,
                isCommenting:  false,
                didInvalidate: true,
                error:         null
            }),
            transform: item => item
        },
        {
            method: 'update',
            action: 'cancelTicket',
            url:    endpoints.serviceNow.cancelIssueEndpoint,
            start:  state => ({
                ...state,
                isCanceling: true,
                error:       null
            }),
            success: state => ({
                ...state,
                isCanceling:   false,
                didInvalidate: true,
                error:         null
            }),
            transform: item => item
        },
        {
            method: 'update',
            action: 'reactivateTicket',
            url:    endpoints.serviceNow.reactivateIssueEndpoint,
            start:  state => ({
                ...state,
                isReactivating: true,
                error:          null
            }),
            success: state => ({
                ...state,
                isReactivating: false,
                didInvalidate:  true,
                error:          null
            }),
            transform: item => item
        },
        {
            method: 'update',
            action: 'reopenTicket',
            url:    endpoints.serviceNow.reopenIssueEndpoint,
            start:  state => ({
                ...state,
                isReopening: true,
                error:       null
            }),
            success: state => ({
                ...state,
                isReopening:   false,
                didInvalidate: true,
                error:         null
            }),
            transform: item => item
        }]
    })
};





// WEBPACK FOOTER //
// ./src/modules/store/issues.js